export const getAdditionalCoverages = `query AdditionalCoverages(
    $policy: HealthCare_PolicyDetailsInput!
) {
    additionalCoveragesHealthCare(input: {
        policyPolicyDetails: [$policy]
    }) {
        data {
            id
            title
            subtext
            tags
            coverageLevels {
                name
                description
            }
            isDefaultOpened
            relevantCostTypeIds
        }
    }
}`;
